/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringequalsaspect8Inputs */

const de__class_stringequalsaspect8 = /** @type {(inputs: _Class_Stringequalsaspect8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist gleich`)
};

/**

* @param {_Class_Stringequalsaspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringequalsaspect8 = /** @type {((inputs?: _Class_Stringequalsaspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringequalsaspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringequalsaspect8(inputs)
});
export { _class_stringequalsaspect8 as "_class_StringEQUALSAspect" }